<template>
	<VueDatePicker
		:aria-labels="{ input: label }"
		range
		:multi-calendars="displayTwoMonths"
		auto-apply
		:enable-time-picker="false"
		:locale="locale"
		:inline="inline"
		:position="position"
		ref="datepicker"
		v-model="dateModel"
	>
		<template #trigger>
			<slot />
		</template>
	</VueDatePicker>
</template>

<script setup lang="ts">
	import type { DatePickerInstance } from '@vuepic/vue-datepicker'
	import VueDatePicker from '@vuepic/vue-datepicker'
	import '@vuepic/vue-datepicker/dist/main.css'
	import { ref } from 'vue'
	import { useI18n } from 'vue-i18n'

	interface Props {
		label?: string
		inline?: boolean
		displayTwoMonths?: boolean
		position?: 'left' | 'center' | 'right'
	}
	const { locale } = useI18n()
	const datepicker = ref<DatePickerInstance>(null)

	withDefaults(defineProps<Props>(), {
		label: '',
		inline: false,
		displayTwoMonths: true,
		position: 'center',
	})

	const dateModel = defineModel<Date[]>()
</script>
<style lang="scss">
	.dp__main * {
		font-family: 'CerebriSans';
	}
	.dp__calendar_item {
		color: var(--color-neutral-900);
		font-style: normal;
		font-weight: 700;
	}

	.dp__date_hover {
		border-radius: 50%;
	}

	.dp__range_start,
	.dp__range_end {
		background-color: var(--color-neutral-900) !important;
		border-radius: 50%;
		border: none;
	}

	.dp__range_between {
		background-color: #dbedfb !important;
		border: none;
	}

	.dp__arrow_top {
		display: none;
	}

	.dp__overlay_cell_active {
		background-color: var(--color-neutral-900);
	}
</style>
